import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from 'supabase/supabaseClient';

const PrivateSignInPage = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Where ProtectedRoute bounced us from, if anywhere.
  const from = location.state?.from
    ? `${location.state.from.pathname}${location.state.from.search || ''}`
    : '/networth';

  const handleAutoSignIn = async (email, password, generationName) => {
    setError('');
    setLoading(true);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    setLoading(false);

    if (error) {
      setError(`Failed to sign in as ${generationName}: ${error.message}`);
    } else {
      navigate(from, { replace: true });
    }
  };

  const generations = [
    { label: 'Boomer', names: 'Bettie & Bob',     email: 'boomers@pocketwatch.money' },
    { label: 'Gen X',  names: 'Jacinda & Joe',    email: 'genx@pocketwatch.money' },
    { label: 'Gen Y',  names: 'Millie & Max',     email: 'geny@pocketwatch.money' },
    { label: 'Gen Z',  names: 'Aisha',            email: 'genz@pocketwatch.money' },
  ];

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '2rem' }}>
      <div style={{ width: '100%', maxWidth: '500px' }}>
        <h1 style={{ marginBottom: '2rem', textAlign: 'center' }}>Private Sign In</h1>

        {error && (
          <div style={{ padding: '1rem', marginBottom: '1rem', backgroundColor: '#fee', border: '1px solid #fcc', borderRadius: '8px', color: '#c33' }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {generations.map((gen) => (
            <button
              key={gen.email}
              className="button large"
              style={{ width: '100%' }}
              onClick={() => handleAutoSignIn(gen.email, '123456', gen.label)}
              disabled={loading}
            >
              {loading ? 'Signing in...' : <><strong>{gen.label}</strong> — {gen.names}</>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivateSignInPage;
